export default function IconPhone() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 2"
      viewBox="0 0 20 20.036"
    >
      <path
        d="M19 14.503v2.715a1.808 1.808 0 0 1-1.974 1.81 17.912 17.912 0 0 1-7.81-2.778 17.649 17.649 0 0 1-5.43-5.43 17.91 17.91 0 0 1-2.779-7.847A1.81 1.81 0 0 1 2.808 1h2.716a1.81 1.81 0 0 1 1.81 1.557c.115.869.326 1.722.633 2.543a1.81 1.81 0 0 1-.407 1.91L6.41 8.158a14.48 14.48 0 0 0 5.43 5.43l1.15-1.15a1.81 1.81 0 0 1 1.91-.407c.82.307 1.674.52 2.543.634a1.81 1.81 0 0 1 1.556 1.837Z"
        data-name="Layer 1"
        style={{
          fill: "none",
          stroke: "var(--color-primary)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
        }}
      />
    </svg>
  );
}
